export const PAGE_NAME = "PAGE_NAME"
export const UNREAD_MESSAGE = "UNREAD_MESSAGE"
